import React from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import './NotFound.css'

const BOOK_URL = 'https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm'

export default function NotFound() {
  return (
    <div className="notfound-page">
      <Container className="notfound-container">
        <div className="notfound-content">
          <span className="notfound-code">404</span>
          <h1 className="notfound-title">Page not found</h1>
          <p className="notfound-desc">
            The page you’re looking for doesn’t exist or has been moved. No worries — let’s get you back on track.
          </p>
          <div className="notfound-actions">
            <Link to="/" className="notfound-btn notfound-btn-primary">
              Back to home
            </Link>
            <a
              href={BOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="notfound-btn notfound-btn-secondary"
            >
              Book an appointment
            </a>
          </div>
          <nav className="notfound-links">
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/location">Location</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>
      </Container>
    </div>
  )
}
